import type {HeuristicRegistry} from '../mobileAlgo'
import type {
    BaseStageData,
    ComponentStageData,
    InnerElementStageData,
    PluginContextHelper,
    PluginHeuristicsRegistry,
    PluginInnerElementStageHandler,
    PluginStageHandler,
    Stage
} from '../types'
import {createPluginContext} from './pluginContext'

export const createPluginHeuristicsRegistry = (
    heuristicRegistryApi: HeuristicRegistry,
    contextHelper: PluginContextHelper
): PluginHeuristicsRegistry => {
    const register = <T extends BaseStageData>(stage: Stage<T>, handler: PluginStageHandler<T>) => {
        const handlerToRegister = async (d: T) => {
            if (contextHelper.isEnabled(d.globalContext)) {
                await handler(d, createPluginContext(contextHelper, d.globalContext))
            }
        }
        heuristicRegistryApi.registerHeuristic(stage, handlerToRegister)
    }

    const registerInnerElementHandler = <T extends ComponentStageData>(
        stage: Stage<T>,
        handler: PluginInnerElementStageHandler
    ) => {
        if (!stage.registerInnerElementHandler) {
            throw new Error('Stage does not support inner element handlers')
        }

        const handlerToRegister = async (data: InnerElementStageData) => {
            if (contextHelper.isEnabled(data.globalContext)) {
                await handler(data, createPluginContext(contextHelper, data.globalContext))
            }
        }

        stage.registerInnerElementHandler(handlerToRegister)
    }

    return {register, registerInnerElementHandler}
}
